// extracted by mini-css-extract-plugin
export var listContainer = "styles-module--listContainer--3fICu";
export var slide = "styles-module--slide--1SGRz";
export var list = "styles-module--list--3_hyU";
export var head = "styles-module--head--2dqvh";